import BreadScrumbs from "../../components/breadscrumb";
import ListCheckBox from "../../components/checkbox";
import { useState } from "react";
import NFTGallery from "../../components/nft-gallery";
function MarketPlacePage() {
    const [tireFilter, setTireFilter] = useState(true)
    const [searchNFT, setSearchNFT] = useState()
    const [listTierPicked, setListTierPicked] = useState({
        tier1: true,
        tier2: true,
        tier3: true,
        tier4: true,
        tier5: true,
        tier6: true,
        tier7: true,
        tier8: true,
    })
    function reListNFT(){
    }
    return (
        <>
            <BreadScrumbs name={'Marketplace'} />
            {/* <Outlet/> */}
            <div className="w-full relative  px-[6.4rem] py-[7.8rem] xl:px-[25.5rem] flex flex-col sm:flex-row sm:justify-between sm:items-start gap-[6.4rem] flex-nowrap">
                <div className="min-w-[23rem] ">
                    <div onClick={() => setTireFilter(!tireFilter)} className=" bg-third  flex justify-between items-center px-[1.2rem] py-[1.6rem] border-b border-b-gray-500">
                        <p className="font-bakbak text-[2rem] text-white">Tire</p>
                        <div className="bg-primary w-[1.3rem] h-[0.3rem]"></div>
                    </div>
                    <div className={`${tireFilter ? 'scale-y-100' : 'scale-y-0 h-0 z-0'} origin-top bg-third w-full h-auto duration-500 p-[2.3rem] `}>
                        <ListCheckBox listTierPicked={listTierPicked} handleCheckBox={reListNFT} />
                    </div>
                </div>
                <div className="">
                    <div className="flex justify-between flex-wrap items-center">
                        <h3 className="text-white whitespace-nowrap mr-[2rem]">All Items</h3>
                        <div className="bg-third px-[2.4rem] py-[1.3rem] flex justify-between items-center">
                            <input className="outline-none bg-transparent text-[#888B8E] text-[1.6rem] font-poppin" onChange={(e) => setSearchNFT(e.value)} type="text" name="searchNft" placeholder="Search NFT" value={searchNFT} />
                            <svg width="2.4rem" height="2.5rem" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11 19.5C15.4183 19.5 19 15.9183 19 11.5C19 7.08172 15.4183 3.5 11 3.5C6.58172 3.5 3 7.08172 3 11.5C3 15.9183 6.58172 19.5 11 19.5Z" stroke="#888B8E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M21.0004 21.5004L16.6504 17.1504" stroke="#888B8E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>

                        </div>
                    </div>
                    <div className="w-full mt-[4rem]">
                        <NFTGallery listTierPicked={listTierPicked} />
                    </div>

                </div>
            </div>
        </>
    )
}

export default MarketPlacePage;